module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/favicon-196x1963ed7a7c4c9f09aad54efc3ec6b049c8d.png";